import React from 'react';
import { Route } from 'react-router-dom';

interface RouteMiddlewareProps {
    isAuthProtected: boolean;
    component: any;
    location?: any;
    layout: any;
    path: any;
    exact?: boolean;
}

const RouteMiddleware: React.FC<RouteMiddlewareProps> = ({ component: Component, layout: Layout, isAuthProtected, ...rest }) => {
    if (rest.path === '/healthcheck') {
        return <h5>App is Healthy</h5>;
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                if (isAuthProtected) {
                    return;
                }

                return (
                    <Layout>
                        <Component {...props} />
                    </Layout>
                );
            }}
        />
    );
};

export default RouteMiddleware;
